<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/weeklist/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="周数">
        <el-select v-model="formModel.week">
          <el-option
            v-for="item in Week"
            :key="item.weekIndex"
            :label="item.week + ' ' + item.date"
            :value="item.weekIndex"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.agentId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="更新时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="rank"
        label="排名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="realName"
        label="姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="agentId"
        label="代理商ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="integral"
        label="积分"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="weekIndex"
        label="周数"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startTime"
        label="开始日期"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="结束日期"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import APPService from "service/APPService";
import TimeRange from "service/constant/TimeRange";
import Month from "service/constant/Month";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "weeklist",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      time: "",
      Week: [
        {
          weekIndex: "",
          week: "全部",
          date: "",
        },
      ],
      formModel: {
        agentId: "",
        week: "",
      },
      tableData: [],
      submitService: APPService.weeklistList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      const params = {
        agentId: this.formModel.agentId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        week: this.formModel.week,
      };
      if (this.time.length) {
        params.startTime = this.time[0];
        params.endTime = this.time[1];
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        week: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getWeek();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getWeek() {
      this.doLoad(
        APPService.weeklistNum,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.Week = [...this.Week, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/RankIng/WeekList.vue